// =============================================================================
// IMPORTS
// =============================================================================
import React from "react";

// =============================================================================
// COMPOSANT FOOTER - Pied de page
// =============================================================================
// Ce composant affiche le pied de page avec les liens vers le portfolio
// et les réseaux sociaux. C'est aussi un composant "présentationnel".

function Footer() {
    return (
        <footer>
            <p>
                Projet pédagogique créé avec <i className="fas fa-heart" style={{ color: '#ef4444' }}></i> et{" "}
                <i className="fab fa-react" style={{ color: '#61dafb' }}></i> React
            </p>
            <p>
                <i className="fas fa-code"></i> Développé par{" "}
                <a href="https://jean-ely-gendrau.students-laplateforme.io" target="_blank" rel="noopener noreferrer">
                    Jean-Ely Gendrau - Portfolio
                </a>
            </p>

            {/* Icônes de réseaux sociaux */}
            <div className="footer-icons">
                <a href="https://github.com/jean-ely-gendrau" target="_blank" rel="noopener noreferrer" title="GitHub">
                    <i className="fab fa-github"></i>
                </a>
                <a href="https://www.linkedin.com/in/jean-ely-gendrau" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                    <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://jean-ely-gendrau.students-laplateforme.io" target="_blank" rel="noopener noreferrer" title="Portfolio">
                    <i className="fas fa-globe"></i>
                </a>
            </div>
        </footer>
    );
}

// =============================================================================
// EXPORT
// =============================================================================
export default Footer;
